<div class="table-responsive" [class.overflow-hidden]="settingsPassOnLogService.emptyRowService.emptyRow.length > 0">
    <table class="table table-striped table-hover footable">
        <thead>
            <tr [ngClass]="{'noSort': settingsPassOnLogService.corporations.data.length < 2}">
                <th style="width: 50px;"></th>
                <th>Property Group Name</th>
                <th>Building Names</th>
                <th>Addresses</th>
            </tr>
        </thead>
        <tbody>
            <ng-template ngFor let-item [ngForOf]="settingsPassOnLogService.corporations.data" let-index="index">
                <tr [ngClass]="{'footable-odd': (index % 2 === 0)}" (click)="$event.showDropdown || toggleCheck(item)">
                    <td>
                        <label class="img-checkbox">
                            <input type="checkbox" [ngModel]="item.checked">
                            <label><svg-checked></svg-checked></label>
                        </label>
                    </td>
                    <td>{{item.name}}</td>
                    <td class="table-hint-td">
                        <div class="table-hint {{index > 7 ? 'up' : 'down'}}">
                            <div *ngFor="let b of item.buildings; let last = last;">
                                {{b.name}}{{!last ? ', ' : ''}}
                            </div>
                        </div>
                        <div class="clickable-text mtv-primary-color" (click)="showHint($event)">
                            <span *ngFor="let b of item.buildings; let last = last;">
                                {{b.name}}{{!last ? ', ' : ''}}
                            </span>
                        </div>
                    </td>
                    <td class="table-hint-td">
                        <div class="table-hint {{index > 7 ? 'up' : 'down'}}">
                            <div *ngFor="let b of item.buildings; let last = last;">
                                {{b.address}}{{!last ? ', ' : ''}}
                            </div>
                        </div>
                        <div class="clickable-text mtv-primary-color" (click)="showHint($event)">
                            <span *ngFor="let b of item.buildings; let last = last;">
                                {{b.address}}{{!last ? ', ' : ''}}
                            </span>
                        </div>
                    </td>
                </tr>
            </ng-template>
            <tr *ngFor="let item of settingsPassOnLogService.emptyRowService.emptyRow" style="cursor: default;">
                <td></td><td></td><td></td><td></td>
            </tr>
        </tbody>
    </table>
    <div *ngIf="settingsPassOnLogService.corporations.data.length === 0 && !settingsPassOnLogService.spinnerShow && !settingsPassOnLogService.showServiceUnavailable"
        class=" text-center">
        <h2>Result Not Found</h2>
        <a class="text-center">
            <broad-match-toggle></broad-match-toggle>
        </a>
    </div>
    <h2 *ngIf="settingsPassOnLogService.showServiceUnavailable" class="text-center">Service Unavailable</h2>
</div>



// WEBPACK FOOTER //
// /app/src/app/views/settings-pass-on-log/settings-pass-on-log-list/settings-pass-on-log-list.component.html